/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiProjectstatusesMutationRequest,
  PostApiProjectstatusesMutationResponse,
} from '../models/PostApiProjectstatuses.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiProjectstatusesMutationResponseSchema,
  postApiProjectstatusesMutationRequestSchema,
} from '../zod/postApiProjectstatusesSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiProjectstatusesMutationKey = () =>
  [{ url: '/api/projectstatuses' }] as const;

export type PostApiProjectstatusesMutationKey = ReturnType<
  typeof postApiProjectstatusesMutationKey
>;

/**
 * {@link /api/projectstatuses}
 */
export async function postApiProjectstatuses(
  data: PostApiProjectstatusesMutationRequest,
  config: Partial<RequestConfig<PostApiProjectstatusesMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiProjectstatusesMutationRequestSchema.parse(data);
  const res = await request<
    PostApiProjectstatusesMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiProjectstatusesMutationRequest
  >({
    method: 'POST',
    url: `/api/projectstatuses`,
    data: requestData,
    ...requestConfig,
  });
  return postApiProjectstatusesMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projectstatuses}
 */
export function usePostApiProjectstatuses<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectstatusesMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiProjectstatusesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiProjectstatusesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectstatusesMutationKey();

  return useMutation<
    PostApiProjectstatusesMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiProjectstatusesMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiProjectstatuses(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
